:host{display:flex;flex-direction:column;height:100%}
/*# sourceMappingURL=add-edit-project-dialog.component-O4EIGYD5.css.map */
